import { all } from './trips'
export const metadata = (id: string) => [...all, 'metadata', id]
